
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.752 12.023C3.611 7.43 7.467 3.75 12.002 3.75a8.25 8.25 0 010 16.5.75.75 0 010-1.5 6.75 6.75 0 000-13.5c-3.75 0-6.864 3.04-6.75 6.727.063 2.066.769 3.446 1.67 4.414v-1.178a.75.75 0 011.5 0v2.9c0 .47-.38.85-.85.85h-2.9a.75.75 0 010-1.5h1.199c-1.154-1.218-2.042-2.948-2.119-5.44zM12 8a.75.75 0 01.75.75v4.19l1.78 1.78a.75.75 0 11-1.06 1.06l-2.22-2.22V8.75A.75.75 0 0112 8z"}})])
          )
        }
      }
    